export const catalogUrlKeys = {
  course_types: 'course_types',
  modalities: 'modalities',
  knowledge_areas: 'knowledge_areas',
  institutions: 'institutions',
  location: 'location',
  price_min: 'price_min',
  price_max: 'price_max',
  terms: 'terms',
  sort: 'sort',
  page: 'page',
  free_courses: 'free_courses',
  unibrad_included: 'unibrad_included',
};

export type CatalogUrlKey =
  (typeof catalogUrlKeys)[keyof typeof catalogUrlKeys];

export type CatalogUrlParams = Partial<{
  [K in CatalogUrlKey]: K extends 'page' ? number : string[];
}> & {
  page?: number;
};
